import fetch, { doGet, doPost } from '../../tools/axios'

export default {
  getWishList ({ page, status, batch, schoolName, type, organizerId, wishNo, keyword, cb }) {
    const query = (status ? `&status=${status}` : '') + (schoolName ? `&school_name=${schoolName}` : '') +
      (wishNo ? `&wish_no=${wishNo}` : '') + (keyword ? `&keyword=${keyword}` : '')
    return fetch('get', `/wishes?page=${page}${query}&batch=${batch}&type=${type || 0}&organizer_id=${organizerId || 1}`, {}, cb)
  },
  getWishItem (id, cb) {
    return fetch('get', `/wishes/${id}`, {}, cb)
  },
  getCommentsList (id, cb) {
    return fetch('get', `/comments?type=wish&wish_id=${id}`, {}, cb)
  },
  submitComments (data, cb) {
    return fetch('post', `/comments`, {data}, cb)
  },
  donate (id, data, cb) {
    return fetch('post', `/wishes/${id}/donate`, { data }, cb)
  },
  voteUp (id, cb) {
    return fetch('post', `/wishes/${id}/voteUp`, {}, cb)
  },
  cancelVote (id, cb) {
    return fetch('post', `/wishes/${id}/cancelVote`, {}, cb)
  },
  sendRead (id) {
    return fetch('post', `/analysis/wishes/${id}/read`)
  },
  getUserWishList (id, batch, cb, page, perPage) {
    const query = (batch ? `&batch=${batch}` : '')
    return fetch('get', `/wish_donates?user_id=${id}${query}&page=${page}&perPage=${perPage}`, {}, cb)
  },
  getWishCount ({ batch, schoolName, organizerId }) {
    const query = (schoolName ? `&school_name=${schoolName}` : '') + (organizerId ? `&organizer_id=${organizerId}` : '')
    return doGet(`/wishes/count?batch=${batch}${query}`)
  },
  getWishTimes (batch) {
    return doGet(`/wishes/times?batch=${batch}`)
  },
  traceWish (wishId) {
    return doPost('/wishes/trace', {
      wish_id: wishId
    })
  },
  untraceWish (wishId) {
    return doPost('/wishes/untrace', {
      wish_id: wishId
    })
  },
  getSchools ({ batch = '', organizerId }) {
    return doGet(`/schools?batch=${batch}&organizer_id=${organizerId}`)
  },
  getWishConfigs ({ organizerId }) {
    return doGet('/wishes/configs', { organizer_id: organizerId })
      .then(res => res.data)
  }
}
